import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {toggleModal} from "../../store/actions/toggleModalActions";
import {getStatusColor, isCompanyAdmin, isCustomer, isDistributorAdmin, isSuperAdmin} from "../../helpers/helpers";
import {getDrainStations, selectDrainStation, setDrainStationsFilters} from "../../store/actions/drainStationsActions";
import Spinner from "../_common/Spinner";
import List from "../_common/List";
import DrainStationModal from "./DrainStationModal";
import DetailsModal from "../_common/DetailsModal";
import DrainStationDetails from "./DrainStationsDetails";
import MapWithPopups from "../MapWithPopups";

const selector = state => {
    const { language, drainStations, modalState, fields, users } = state;
    return {
        t: language.translator,
        pending: drainStations.pending,
        drainStations: drainStations.drainStations,
        page: drainStations.page,
        pageCount: drainStations.pageCount,
        itemsCount: drainStations.itemsCount,
        selected: drainStations.selected,
        filters: drainStations.filters,
        modalState: modalState,
        fields: fields.fields,
        filteredUser: users.filtered,
    }
};
const DrainStations = props => {
    const {stationPicker, selectStationPicker, toggleStationPicker} = props;
    const { t, pending, drainStations, page, pageCount, itemsCount, modalState, selected, filters, fields, filteredUser } = useSelector(selector)
    const dispatch = useDispatch();

    const [filter, setFilter] = useState('ALL');
    const [search, setSearch] = useState('');

    const [hideMap, setHideMap] = useState(isSuperAdmin() || isCompanyAdmin() || isCustomer() || isDistributorAdmin());
    const [itemsPerPage, setItemsPerPage] = useState(hideMap ? 10 : 3);

    useEffect(() => {
        if(isCompanyAdmin() || isSuperAdmin() || isDistributorAdmin()) {
            // dispatch(filterUser({}));
            dispatch(getDrainStations(1, itemsPerPage, filter, '', ''));
        } else {
            dispatch(getDrainStations(1, itemsPerPage, filter, '', ''));
        }
        if(!stationPicker) {
            closeModal()
        }
    }, []);

    const closeModal = () => {
        dispatch(toggleModal(false, ''))
    };


    let drainStationsMarkers = [];

    if(drainStations.length) {
        drainStations.forEach(station => {
            if (station.lat && station.lon) {
                drainStationsMarkers.push(
                    {
                        lat: station?.lat,
                        lng: station?.lon,
                        color: getStatusColor(station?.temperatureStatus),
                        name: station.name,
                        id: station.id
                    }
                )
            }
        });
    }


    return (
        <div className="communitySensors">
            {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) && !stationPicker && (
                <div className={!hideMap ? 'sensorMap sensorMap--expanded' : 'sensorMap'}>
                    {/*<SensorsMap*/}
                    {/*    defaultZoom={5.8}*/}
                    {/*    defaultCenter={{lat: 52.2297, lng: 21.0122}}*/}
                    {/*    markers={weatherStationsMarkers}*/}
                    {/*/>*/}
                    <MapWithPopups
                        zoom={6}
                        center={{lat: 52.2297, lng: 21.0122}}
                        markers={drainStationsMarkers}
                        mapType={'sensors'}
                    />
                    <div
                        className='hideMapButton'
                        onClick={() => {
                            // dispatch(setWeatherStationsFilters({active: filter, itemsPerPage, search: filters.search}))
                            dispatch(getDrainStations(1, itemsPerPage, filter, '', ''));
                            setHideMap(!hideMap)
                        }}
                    >
                    <span className='material-icons hideMapButtonIcon'>
                        {hideMap ? 'expand_more' : 'expand_less'}
                    </span>
                    </div>
                </div>
            )}
            <form className='sensorFilter stationFilter'>
                <div className='searchInputWrapper'>
                    <input
                        type='text'
                        className='sensorSearchInput'
                        placeholder={t.gettext('Search')}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    {filters.search
                        ? <span
                            className='material-icons sensorSearchCancelButton'
                            onClick={() => {
                                dispatch(setDrainStationsFilters({active: filter, itemsPerPage, search: ''}))
                                setSearch('');
                                dispatch(getDrainStations(1, itemsPerPage, ''));
                            }}
                        >
                            cancel
                        </span>
                        : null
                    }
                </div>
                <button
                    className='sensorSearchButton'
                    onClick={e => {
                        e.preventDefault();
                        dispatch(setDrainStationsFilters({active: filter, itemsPerPage, search}))
                        dispatch(getDrainStations(1, itemsPerPage, search));
                    }}
                    disabled={!search}
                >
                    {t.gettext('SEARCH')}
                </button>
                <label htmlFor='itemsPerPage' className={'itemsPerPageLabel'}>
                    {t.gettext('Items per page')}
                </label>
                <input
                    type='number'
                    id='itemsPerPage'
                    className='sensorSearchInput itemsPerPageInput'
                    min={1}
                    step={1}
                    defaultValue={itemsPerPage}
                    onChange={e => {
                        e.preventDefault();
                        if (e.target.value) {
                            setItemsPerPage(e.target.value < 1 ? 1 : e.target.value);
                            dispatch(setDrainStationsFilters({
                                active: filter,
                                itemsPerPage: e.target.value < 1 ? 1 : e.target.value,
                                search: filters.search
                            }));
                            dispatch(getDrainStations(1, e.target.value < 1 ? 1 : e.target.value, filter, filteredUser.id ? filteredUser.id : '', filters.search));
                        }
                    }}
                />
                <div className="addStationWrapper">
                    <div className="addStationBtn" onClick={() => dispatch(toggleModal(true, 'Add Station'))}>
                        {t.gettext('Add Station')}
                    </div>
                </div>
            </form>
            <div className={'sensorList sensorList--expanded'}>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={drainStations}
                        page={page}
                        itemsPerPage={itemsPerPage}
                        pageCount={pageCount}
                        itemsCount={itemsCount}
                        columnsNames={isCustomer() ?  ['Station Name', 'In Sensor', 'Out Sensor', 'Proportion Multiplier', 'Proportion Divider'] : ['User Name', 'Station Name', 'In Sensor', 'Out Sensor', 'Proportion Multiplier', 'Proportion Divider']}
                        columns={isCustomer() ? ['name', 'inWaterCountSensorId', 'outWaterCountSensorId', 'multiplier', 'divider'] : ['userName', 'name', 'inWaterCountSensorId', 'outWaterCountSensorId', 'multiplier', 'divider']}
                        columnsWidths={isCustomer() ? ['20%', '20%', '20%', '20%', '20%'] : ['20%', '20%', '20%', '20%', '10%', '10%']}
                        filter={filter}
                        inSensorColumn={isCustomer() ? 2 : 3}
                        outSensorColumn={isCustomer() ? 3 : 4}
                        getItemsMethod={getDrainStations}
                        picker={stationPicker}
                        selectItemMethod={stationPicker ? selectStationPicker : selectDrainStation}
                        onSelectModalName={stationPicker ? toggleStationPicker : 'Station details'}
                        userId={filteredUser.id ? filteredUser.id : ''}
                        search={filters.search}
                    />
                }
                {(modalState.flag && modalState.modal === 'Add Station') && (
                    <DrainStationModal />
                )}
                {(modalState.flag && modalState.modal === 'Station details') &&
                    <DetailsModal
                        closeMethod={closeModal}
                    >
                        <DrainStationDetails
                            station={selected.station}
                        />
                    </DetailsModal>
                }
            </div>
        </div>
    )
}

export default DrainStations
